export default "__VITE_ASSET__Upgo8v86__"